var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.stickyClass,
      style: { zIndex: _vm.zIndex, "min-height": _vm.height + "px" },
    },
    [
      _c(
        "div",
        {
          class: _vm.className,
          style: {
            top: _vm.stickyTop + "px",
            zIndex: _vm.zIndex,
            position: _vm.position,
            left: _vm.cssLeftAttributeVal,
            right: _vm.cssRightAttributeVal,
            width: _vm.width,
          },
        },
        [
          _c(
            "div",
            { class: [{ row: _vm.active, "align-center": _vm.active }] },
            [
              _c(
                "div",
                {
                  class: [
                    {
                      "sticky-content": _vm.active,
                      "medium-12": _vm.active,
                      "small-12": _vm.active,
                      columns: _vm.active,
                      "large-12": _vm.active,
                    },
                  ],
                },
                [_vm._t("default")],
                2
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }